import $ from 'jquery';
import { ICON } from '../Icons/Icons';
export default class RealPlayerChessIndicator {
  constructor(container, icon, indicatorId) {
    this.containerId = container;
    this.$indicator = container;
    // Create the player indicator structure with layers
    this.$indicator.html(`
      <div class="video-stack">
        <div class="media-container">
          <div class="text-holder">
            <p>Take this seat to play as Black</p>
          </div>
          <div class="empty-container">
          </div>
          <div class="icon-container">
            ${icon}
          </div>
          <div class="time-icon-container">
            ${ICON.TIME}
          </div>
          <div class="image-wrapper"></div>
          <div class="video-wrapper"></div>
          <div class="speaking-indicator" style="display: none;">
            <span></span><span></span><span></span>
          </div>
        </div>
        <div class="video-name">
          <span></span>
        </div>
      </div>
    `);

    // Get references to the elements
    this.$mediaContainer = this.$indicator.find('.media-container');
    this.$videoWrapper = this.$indicator.find('.video-wrapper');
    this.$emptyContainer = this.$indicator.find('.empty-container');
    this.$imageWrapper = this.$indicator.find('.image-wrapper');
    this.$iconContainer = this.$indicator.find('.icon-container');
    this.$nameElement = this.$indicator.find('.video-name span');
    this.$timeIconContainer = this.$indicator.find('.time-icon-container');
    this.$speakingIndicator = this.$indicator.find('.speaking-indicator');
    this.$textHolder = this.$indicator.find('.text-holder p');
    this.hideTimeIcon();
  }

  showVideo(videoElement) {
    // Show video wrapper and hide other layers
    this.$videoWrapper.show();
    this.$imageWrapper.hide();
    this.$emptyContainer.hide();
    this.$textHolder.hide();
    // Append the video element to the video wrapper
    this.$videoWrapper.append(videoElement);

    // Apply necessary styles to the video element
    videoElement.css({
      'width': '100%',
      'height': '100%',
      'object-fit': 'cover',
      'display': 'block'
    });
    this.$mediaContainer.addClass('active');
  }
  getVideoElement() {
    return this.$videoWrapper.find('video');
  }

  showAvatar(avatarUrl) {
    // Hide video wrapper and show image wrapper
    this.$videoWrapper.hide();
    this.$imageWrapper.show();
    this.$emptyContainer.hide();
    this.$textHolder.hide();
    this.hideTimeIcon();

    // Update the avatar image
    const $avatarImg = this.$imageWrapper.find('img');
    if ($avatarImg.length === 0) {
      this.$imageWrapper.append(`<img src="${avatarUrl}" alt="Player Avatar">`);
    } else {
      $avatarImg.attr('src', avatarUrl);
    }
    this.$mediaContainer.addClass('active');
  }

  showEmpty() {
    // Hide video and image wrappers, show icon container
    this.$videoWrapper.hide();
    this.$imageWrapper.hide();
    this.$emptyContainer.show();
    this.$nameElement.text('');
    this.$nameElement.hide();
    this.$textHolder.show();
    this.hideTimeIcon();
    this.hideSpeakingIndicator();
    this.$mediaContainer.removeClass('active');
  }

  setName(name) {
    if (this.$nameElement.length) {
      this.$nameElement.text(name);
      this.$nameElement.show();
    }
  }

  onClick(callback) {
    this.$indicator.on('click', callback);
  }

  offClick(callback) {
    this.$indicator.off('click', callback);
  }

  showTimeIcon() {
    this.$timeIconContainer.show();
  }

  hideTimeIcon() {
    this.$timeIconContainer.hide();
  }

  showSpeakingIndicator() {
    this.$speakingIndicator.show();
  }

  hideSpeakingIndicator() {
    this.$speakingIndicator.hide();
  }

  setSpeakingIndicatorStatus(isActive) {
    this.$speakingIndicator.toggleClass('speaking-indicator--active', isActive)
  }

  clear() {
    this.$imageWrapper.hide();
    this.$emptyContainer.show();
    this.$nameElement.text('');
    this.$nameElement.hide();
    this.$timeIconContainer.hide();
    this.$textHolder.hide();
    this.setSpeakingIndicatorStatus(false)
    this.hideSpeakingIndicator()
    this.$mediaContainer.removeClass('active');
  }
}
